import React from "react";
import { getGlobalValue } from "@argonaut/global-store";
var defaultContext = {
  portals: [],
  registerPortal: () => {},
  deregisterPortal: () => {}
};
export default getGlobalValue({
  key: "PortalContext",
  moduleName: "@construct-kit/core",
  createValue: () => /*#__PURE__*/React.createContext(defaultContext)
});